import styled from '@emotion/styled';

import { COLOR_TEXT_PRIMARY } from './utils/variables';

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: ${COLOR_TEXT_PRIMARY};
  letter-spacing: -0.02em;
`;
